/** Browser-safe display contract. Spending controls and cryptographic provenance stay on the server. */
export const ARTICLE_CUSTOM_IMAGE_START_DATE = '2026-09-26'
export function requiresCustomArticleImage(article: { kind: string; publishedAt?: string; generatedAt: string }): boolean {
  const published = new Date(article.publishedAt ?? article.generatedAt)
  const localDay = Number.isFinite(published.getTime()) ? new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(published) : ''
  return article.kind === 'ai-synthesis' && Boolean(localDay) && localDay >= ARTICLE_CUSTOM_IMAGE_START_DATE
}
